import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {
    config_marketplace_template,
    MP_HOME_FILTER_FEATURED
} from "../components/templates/config_marketplace_template";
import {config_marketplace_providers_template} from "../components/templates/config_marketplace_providers_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;


export class config_marketplace extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: any = {};
    protected configMarketplace: config_marketplace_template;
    protected configProviders: config_marketplace_providers_template;
    protected _isLeavePageWarningNeeded: boolean = true;
    protected _tagSuggestionIdElement: string = MP_HOME_FILTER_FEATURED;

    private isInternalMarketplace(): boolean {
        return window.location.pathname.indexOf('/config/marketplace-internal/') !== -1;
    }

    private settingsEndpoint(): string {
        return this.isInternalMarketplace() ? 'marketplace-internal-settings' : 'marketplace-settings';
    }

    private providersEndpoint(): string {
        return this.isInternalMarketplace() ? 'marketplace-internal-providers-settings' : 'marketplace-providers-settings';
    }

    private configRoute(): string {
        return this.isInternalMarketplace() ? 'marketplace-internal' : 'marketplace';
    }

    public fillPage() {
        this.getMarketplaceConfigData();
        this.getProvidersConfigData();
        this.applyInitialViewType();
    }

    buildContent(): Array<Element> {
        this.configProviders = new config_marketplace_providers_template("providersPanel", this.viewModel, this);
        this.configMarketplace = new config_marketplace_template("config_marketplace", this.viewModel, this);
        this.configMarketplace.getTemplateViewModel().internalMode(this.isInternalMarketplace());
        this.configProviders.getTemplateViewModel().internalMode(this.isInternalMarketplace());
        this.configMarketplace.getTemplateViewModel().providersPanel = this.viewModel.providersPanel;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle(this.isInternalMarketplace() ? "Internal Marketplace Settings" : "Marketplace Settings");

        return [this.configMarketplace.build()];
    }

    protected getModuleName(): string {
        return "config_marketplace";
    }

    /**
     * Open the Providers tab when the marketplace page is loaded with #providers.
     */
    private applyInitialViewType() {
        if ((window.location.hash || '') === '#providers') {
            this.configMarketplace.getTemplateViewModel().viewType('providers');
        }
    }

    private getMarketplaceConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/" + this.settingsEndpoint() + "/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetMarketplaceConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetMarketplaceConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                let response = responseParsed.data;

                obj.configMarketplace.setMarketplaceSettings(response.marketplaceSettings, response.brandSiteUrl);

            });
        }
    }

    private getProvidersConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/" + this.providersEndpoint() + "/get/";
        let usrReq_params: Array<Array<string>> = [];
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        XHRHdl.onReadyStateFunction = this.onGetProvidersConfigDataReturn;
        XHRHdl.execute();
    }

    private onGetProvidersConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let response = responseParsed.data;
                obj.configProviders.setProvidersSettings(response.providers, response.provider_caps);
            });
        }
    }

    protected saveMarketplaceSettings() {
        this.loadingIn(this.configMarketplace.builtTemplate);
        this.configMarketplace.syncAllHomeTagSectionsFromFilters();
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/" + this.settingsEndpoint() + "/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configMarketplace.getMarketplaceSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/"+idBrand+"/config/" + obj.configRoute() + "/");
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Marketplace settings saved!");

                });
                obj.loadingOut(obj.configMarketplace.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    protected saveProvidersSettings() {
        this.loadingIn(this.configMarketplace.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/" + this.providersEndpoint() + "/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configProviders.getProvidersSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/" + idBrand + "/config/" + obj.configRoute() + "/#providers");
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_SUCCESS,
                        "Provider settings saved!"
                    );
                });
                obj.loadingOut(obj.configMarketplace.builtTemplate);
            };
        });
        XHRHdl.execute();
    }

    protected cancelSiteSettings() {
        this.backAction('settings');
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Marketplace settings changes cancelled!");
    }

    protected cancelProvidersSettings() {
        this.backAction('providers');
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Provider settings changes cancelled!");
    }

    protected backAction(activeView: string = 'settings'){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (activeView === 'providers') {
            page.redirect("/brand/"+idBrand+"/config/" + this.configRoute() + "/#providers");
            return;
        }
        page.redirect("/brand/"+idBrand+"/config/" + this.configRoute() + "/");
    }

    protected getTagsSuggestion(keyword: string, idElement: string) {
        if ("getTagsSuggestion" in this.XHRHdls && this.XHRHdls["getTagsSuggestion"]) {
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        this._tagSuggestionIdElement = idElement;
        const subViewModel = { filter: { keyword: keyword, idTagType: 972, getNonSelectable: true }, idElement: idElement };
        const usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getTagsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getTagsSuggestion"].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls["getTagsSuggestion"].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data && responseParsed.data.tags) {
                    obj.configMarketplace.setHomeTagSuggestions(obj._tagSuggestionIdElement, responseParsed.data.tags);
                }
            });
        };
    }

    protected filterSimpleOnChange(idElement: string) {
        this.configMarketplace.syncHomeTagSectionFromFilter(idElement, true);
    }

    protected getArticlesSuggestion(keyword: string, idElement: string) {
        if ("getArticlesSuggestion" in this.XHRHdls && this.XHRHdls["getArticlesSuggestion"]) {
            this.XHRHdls["getArticlesSuggestion"].cancelAndReset();
        }

        const subViewModel = { list: { keyword: keyword }, idElement: idElement };
        const usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/article/";
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getArticlesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getArticlesSuggestion"].onReadyStateFunction = this.onGetArticlesSuggestionReturn;
        this.XHRHdls["getArticlesSuggestion"].execute();
    }

    protected onGetArticlesSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.articles && responseParsed.data.idElement) {
                    obj.configMarketplace.setArticleFilterAutocomplete(
                        responseParsed.data.idElement,
                        responseParsed.data.articles
                    );
                }
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_marketplace.ts